export enum UserSyncDbResult {
  NoSyncNeeded,
  UserCreated,
  UserUpdated,
  MappingsCreated,
  InvalidAuthUserId,
  InvalidEmail,
  Error,
}
